import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        // Larger, more readable defaults. Title is text-lg (18px) bold,
        // description is text-base (16px) with relaxed leading so the body
        // doesn't feel dense. Card is wider and gets a chunkier padding so
        // the type has room to breathe. These override sonner's default
        // ~13px sizing which was too small to read at a glance.
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:p-5 group-[.toaster]:min-w-[380px]",
          title: "group-[.toast]:text-lg group-[.toast]:font-semibold group-[.toast]:leading-snug",
          description: "group-[.toast]:text-base group-[.toast]:text-muted-foreground group-[.toast]:leading-relaxed",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-base group-[.toast]:font-medium group-[.toast]:px-3 group-[.toast]:py-1.5",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-base",
          closeButton:
            "group-[.toast]:bg-background group-[.toast]:border-border",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
